// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3yN1j","errorLogs":"EditorFooter_errorLogs__1Oz3d"};